const remainDays = (date: string) => {
  const oneDay = 24 * 60 * 60 * 1000;
  const currentDate = Number(new Date());
  const expireDate = Number(new Date(date));
  const diffDays = Math.round(Math.abs((currentDate - expireDate) / oneDay));
  return diffDays;
};

export default remainDays;
